import { CircularProgress } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";
import { useAISummaryStore } from "../../store/aiSummaryStore";
import { STRINGS } from "../../utils/strings";

import NothingSelectedContainer from "./NothingSelectedContainer";

export default function RightBottomPanel() {
  const { selectedSummaryNoteContent, chipData, summaryNoteLoading, resultCount } =
  useAISummaryStore();

  if (summaryNoteLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center py-4">
        <CircularProgress style={{ color: HNSColors.secondary[500] }} />
      </div>
    );
  }

  if (!selectedSummaryNoteContent) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <NothingSelectedContainer />
      </div>
    );
  }

  const hasChips = chipData?.length > 0;

  return (
    <div
      className={`relative flex h-full w-full flex-1 flex-col overflow-auto 
        ${resultCount <= STRINGS.DEFAULT_PAGINATION_LIMIT ? "" : "mb-10"}
        ${hasChips ? "mt-12" : "mt-2"}
        [&::-webkit-scrollbar-thumb]:bg-blue-700
        [&::-webkit-scrollbar]:w-1.5
        px-4
        py-2
      `}
    >
  <div
    className="absolute h-full prose max-w-full"
    dangerouslySetInnerHTML={{ __html: selectedSummaryNoteContent }}
  />
    </div>
  );
}
